import { render } from "./TotalPoints.vue?vue&type=template&id=ebea19e0&scoped=true"
import script from "./TotalPoints.vue?vue&type=script&lang=js"
export * from "./TotalPoints.vue?vue&type=script&lang=js"

import "./TotalPoints.vue?vue&type=style&index=0&id=ebea19e0&scoped=true&lang=css"

import exportComponent from "/home/admin/sites/imdibil.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebea19e0"]])

export default __exports__